import { useQuery } from '@tanstack/react-query';
import { useApi } from '../api/ApiProvider.js';
import { isoDate } from '../lib/localDate.js';

/**
 * A classroom's effective (carry-forward) per-day config — message +
 * question-of-the-day. Defaults to today's classroom-local date. Shares the
 * query key `['classroom-day', id, date]` with the settings editors so a save
 * updates the live screen without a reload (mirrors useClassroomSettings).
 */
export function useClassroomDay(classroomId: string | null | undefined, date: string = isoDate()) {
  const api = useApi();
  return useQuery({
    queryKey: ['classroom-day', classroomId ?? 'none', date],
    queryFn: () => api.dayHistory.getDay(classroomId as string, date),
    enabled: !!classroomId,
  });
}
